import { render } from "./BudgetTemplateShow.vue?vue&type=template&id=3070e9b2&scoped=true"
import script from "./BudgetTemplateShow.vue?vue&type=script&lang=js"
export * from "./BudgetTemplateShow.vue?vue&type=script&lang=js"

import "./BudgetTemplateShow.vue?vue&type=style&index=0&id=3070e9b2&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3070e9b2"]])

export default __exports__